import React from 'react';
import { SPACE } from '@utils/constants';

export const Ordinal = ({ edition }: { edition: number }) => {
  return (
    <span className="font-base text-base-s font-semibold md:text-base-m lg:text-base-l">
      #{`${edition}`}
      {SPACE}
    </span>
  );
};
